import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import Truncate from 'react-truncate';
import ParseHTML from 'components/atoms/ParseHTML';

type State = {|
  isOpen: boolean
|};

type Props = {|
  benefits: string,
  target: string,
  ns: string
|};

export default class ServiceBenefits extends Component<Props, State> {
  static handleDocumentClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  constructor(props) {
    super(props);

    this.state = { isOpen: false };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
    if (this.state.isOpen) {
      document.addEventListener(
        'click',
        ServiceBenefits.handleDocumentClick,
        true
      );
    } else {
      setTimeout(
        () =>
          document.removeEventListener(
            'click',
            ServiceBenefits.handleDocumentClick,
            true
          ),
        0
      );
    }
  }

  render() {
    const { benefits, target, ns } = this.props;
    return (
      <div>
        <Truncate
          className={`${ns}__benefits`}
          lines={2}
          id={target}
          ellipsis="…"
          aria-disabled={true}
        >
          <ParseHTML useHelper={false} html={benefits} />
        </Truncate>
        <Tooltip
          className={`${ns}__tooltip`}
          isOpen={this.state.isOpen}
          toggle={this.toggle}
          placement="bottom-start"
          target={target}
          modifiers={{
            preventOverflow: { boundariesElement: 'viewport' }
          }}
          trigger="hover"
        >
          <ParseHTML useHelper={false} html={benefits} />
        </Tooltip>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ServiceBenefits/ServiceBenefits.js